module.exports = __webpack_public_path__ + "32473ec3b4a75745b6b6a150fd721a75.png";